<template>
  <div
    v-if="
      [
        EXECUTION_STATUS.NOT_STARTED,
        EXECUTION_STATUS.DATA_INIT,
        EXECUTION_STATUS.WAITING,
        EXECUTION_STATUS.PROCESSING,
        EXECUTION_STATUS.ERROR,
      ].includes(dataSource.status)
    "
    class="progress-card cursor-pointer"
    @click="showProgress"
  >
    <!-- @click.stop.prevent="$emit('click', dataSource)" -->

    <!-- <a @click="showProgress">点击展示</a> -->
    <div
      v-if="
        [EXECUTION_STATUS.WAITING, EXECUTION_STATUS.PROCESSING].includes(
          dataSource.status
        ) &&
        (dataSource?.xihe_remaining_time || dataSource?.xihe_queue_wait_time)
      "
      class="tip"
    >
      <div class="label">{{ $t('yu-ji-deng-dai-shi-jian') }}</div>
      <div class="time">
        {{
          getFormateTime(
            EXECUTION_STATUS.PROCESSING === dataSource.status
              ? dataSource?.xihe_remaining_time
              : dataSource.xihe_queue_wait_time
          )
        }}
      </div>
    </div>
    <div class="content">
      <template v-if="dataSource.status === EXECUTION_STATUS.WAITING">
        <iconpark-icon name="queue" size="32" class="mt-[10px]"></iconpark-icon>
        <div class="title">{{ $t('he-cheng-dui-wu-pai-dui-zhong') }}</div>
        <div v-if="dataSource.xihe_pending_task_count" class="sub-title">
          {{ $t('qian-fang-deng-dai-he-cheng-de-shi-pin-shu') }}
          {{ dataSource.xihe_pending_task_count }}
        </div>
      </template>
      <template v-else-if="dataSource.status === EXECUTION_STATUS.PROCESSING">
        <a-progress
          v-if="dataSource?.xihe_percentage !== undefined"
          type="circle"
          :size="60"
          :strokeColor="dataSource.is_speed ? '#FFB53D' : '#6962FF'"
          :percent="Math.round(dataSource.xihe_percentage)"
        />
        <iconpark-icon v-else name="loading" size="42" class="animate-spin">
        </iconpark-icon>
        <a-popover :content="$t('guan-bi-he-cheng')">
          <iconpark-icon
            name="close"
            size="16"
            class="absolute top-[10px] right-[10px] cursor-pointer"
            @click.stop.prevent="handleCancelTask(dataSource)"
          ></iconpark-icon>
        </a-popover>
        <div v-if="description" class="title mt-[5px]">{{ description }}</div>
      </template>
      <template v-else-if="dataSource.status === EXECUTION_STATUS.ERROR">
        <a-popover :content="$t('guan-bi-ren-wu')">
          <iconpark-icon
            name="close"
            size="16"
            class="absolute top-[10px] right-[10px] cursor-pointer"
            @click.stop.prevent="handleCloseTask(dataSource)"
          ></iconpark-icon>
        </a-popover>
        <iconpark-icon name="close-fill" size="32"></iconpark-icon>
        <div class="title mt-[5px]">{{ $t('shi-pin-he-cheng-shi-bai') }}</div>
        <a-button
          type="primary"
          class="mt-[14px]"
          :loading="loading"
          @click.stop.prevent="handleRetry(dataSource)"
        >
          {{ $t('zhong-xin-he-cheng') }}
        </a-button>
      </template>
      <template v-else>
        <div class="init-loading"></div>
        <div class="title mt-[5px]">{{ $t('ren-wu-chu-shi-hua-zhong') }}</div>
      </template>
      <a-space
        v-if="
          [
            EXECUTION_STATUS.NOT_STARTED,
            EXECUTION_STATUS.DATA_INIT,
            EXECUTION_STATUS.WAITING,
          ].includes(dataSource.status)
        "
        class="mt-[7px]"
      >
        <div
          v-if="
            allowAccelerate &&
            !(dataSource?.tip || Boolean(dataSource?.is_speed))
          "
          class="relative"
        >
          <a-button
            :disabled="dataSource?.tip || Boolean(dataSource?.is_speed)"
            size="small"
            type="primary"
            class="relative"
            @click.stop.prevent="$emit('accelerate', dataSource)"
          >
            <span>
              <iconpark-icon
                name="lightning"
                size="14"
                class="align-sub"
              ></iconpark-icon>
            </span>
            <span>{{ $t('pai-dui-jia-su') }}</span>
            <!-- <span class="ml-[4px] inline-block">
              <a-popover
                v-if="dataSource?.tip"
                :content="
                  $t(
                    'jin-ri-30-ge-pai-dui-jia-su-mingeyi-xiao-hao-wan-bi-qing-ming-ri-zai-lai-ba'
                  )
                "
              >
                <iconpark-icon
                  name="info-circle"
                  size="12"
                  class="align-middle mb-[3px]"
                  fill="#FFFFFF"
                ></iconpark-icon>
              </a-popover>
            </span> -->
          </a-button>
        </div>
        <div v-if="allowCancelQueue">
          <a-button
            size="small"
            @click.stop.prevent="handleCancelTask(dataSource)"
          >
            {{ $t('qu-xiao-he-cheng') }}
          </a-button>
        </div>
      </a-space>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { VNode } from 'vue'
import { useAddStorage } from '../paymentDesk'
import { COPYWRITING_MAP as getCopyWritingMap } from './config'
import { cancelTask, deletePieces, resynthesis } from '~/api'
import { useConfirm } from '~/hooks/useModal/modals/confirm'
import { useDetector } from '~/hooks/useDetector'
import { useTime } from '~/hooks/useTime'
import { useUpgrade } from '~/hooks/useUpgrade'
import { ORDER_BEHAVIOR, ORDER_TYPE, RIGHTS_FEATURE } from '~/api/interface'
import { showPieces } from '~/hooks/useModal/modals/piecesView'
const { $t } = useNuxtApp()

const COPYWRITING_MAP = getCopyWritingMap()
const { getFormateTime } = useTime()
const route = useRoute()

const props = withDefaults(
  defineProps<{
    dataSource?: any
    allowAccelerate?: boolean // 是否允许排队加速。只有个人版才有
    description?: string
    allowCancelQueue?: boolean // 是否允许取消排队，个人版和团队版管理员可操作
    from?: { target: TARGET_FROM; source: SOURCE }
    shareToOuterUser?: boolean
  }>(),
  {
    dataSource: () => ({}),
    allowAccelerate: false,
    allowCancelQueue: false,
  }
)

const emits = defineEmits(['reload', 'remove', 'accelerate', 'click'])

const loading = ref(false)

const processStorageLack = () => {
  // 处理存储空间不够时的错误展示
  const { isRightTaste, isRightPersonal, isTeamRight, isAdmin } = useDetector()
  const userInfo = useUserInfo()
  const $t = useNuxtApp().$t

  let content: (VNode | string)[] = []

  if (isTeamRight.value) {
    if (isAdmin.value) {
      content = [
        '云存储空间已满，请',
        h(
          'a',
          {
            type: 'link',
            onClick: () =>
              useAddStorage({
                title: $t('jia-gou-cun-chu-kong-jian'),
                user_info: userInfo.value,
                behavior: ORDER_BEHAVIOR.ADD_PURCHASE,
                feature_type: RIGHTS_FEATURE.storage,
                order_type: ORDER_TYPE.STORAGE,
              }),
          },
          '加购存储空间'
        ),
        '后操作',
      ]
    } else {
      content = ['云存储空间已满，请联系管理员加购存储空间后操作']
    }
  } else {
    if (isRightTaste.value) {
      content = [
        '云存储空间已满，请',
        h(
          'a',
          { type: 'link', onClick: () => useUpgrade('upgrade') },
          '升级权益'
        ),
        '后操作',
      ]
    }
    if (isRightPersonal.value) {
      content = [
        '云存储空间已满，请',
        h(
          'a',
          {
            type: 'link',
            onClick: () =>
              useAddStorage({
                title: $t('jia-gou-cun-chu-kong-jian'),
                user_info: userInfo.value,
                behavior: ORDER_BEHAVIOR.ADD_PURCHASE,
                feature_type: RIGHTS_FEATURE.storage,
                order_type: ORDER_TYPE.STORAGE,
              }),
          },
          '加购存储空间'
        ),
        '后操作',
      ]
    }
  }

  return message.info({
    content: h('div', content),
    type: 'warning',
    duration: 3,
  })
}

const dataInfo = computed(() => props.dataSource)

// const ttt = computed(() => {
//   let time = 1
//   setTimeout(() => (time += 1), 1000)
//   return time
// })

// const onSpeed =()

const showProgress = () => {
  showPieces({
    val: dataInfo.value,
    from: props.from,
    allowAccelerate: props.allowAccelerate,
    allowCancelQueue: props.allowCancelQueue,
    shareToOuterUser: props.shareToOuterUser,
    actions: {
      retry: () => handleRetry(props.dataSource), // 重新合成
      cancel: () => handleCancelTask(props.dataSource), // 取消合成
      speed: () => emits('accelerate', props.dataSource), // 排队加速
      // cancelSpeed: () => handleCancelQueue(props.dataSource, true), // 取消排队
    },
  })
}

watch(
  () => route.query?.progress,
  (cur) => {
    if (
      Number(cur) === props.dataSource.id &&
      [
        EXECUTION_STATUS.NOT_STARTED,
        EXECUTION_STATUS.DATA_INIT,
        EXECUTION_STATUS.WAITING,
        EXECUTION_STATUS.PROCESSING,
        EXECUTION_STATUS.ERROR,
      ].includes(props.dataSource.status)
    ) {
      showProgress()
    }
  },
  { immediate: true }
)

// 重新合成
const handleRetry = async (record: any) => {
  if (record?.id) {
    loading.value = true
    const response: any = await resynthesis(
      { id: record?.id },
      { autoErrorHandle: false }
    )
    loading.value = false
    if (response.code === 0) {
      message.success($t('cao-zuo-cheng-gong'))
      emits('reload')
    } else if (response.code === 11023) {
      processStorageLack()
    } else {
      message.error(response.error_reason)
    }
  }
}

// 关闭任务
const handleCloseTask = async (record: any) => {
  const res = await deletePieces({ ids: [record.id] })
  if (res.code === 0) {
    emits('remove', [record.id])
    message.success($t('guan-bi-cheng-gong'))
  } else {
    message.error($t('guan-bi-shi-bai'))
  }
}

const handleCancel = async (record: any, isQueue = false) => {
  try {
    const response: any = await cancelTask({
      ids: [record?.generate_record_task_id ?? record?.model_id ?? record.id],
    })
    if (response.code === 0) {
      message.success(
        isQueue
          ? $t('yi-qu-xiao-pai-dui')
          : COPYWRITING_MAP[COLLECTION_MAP.PIECES].successText
      )
      emits('reload')
    } else {
      message.error(
        isQueue
          ? $t('qu-xiao-shi-bai')
          : COPYWRITING_MAP[COLLECTION_MAP.PIECES].errorText
      )
    }
  } catch (error) {
    console.error(error)
  }
}

// 取消排队
// const handleCancelQueue = (record: any, isQueue = false) => {
//   useConfirm({
//     icon: true,
//     title: $t('qu-xiao-pai-dui'),
//     description: $t(
//       'gai-cheng-pian-zheng-zai-deng-dai-he-cheng-pai-dui-zhong-ru-guo-guan-bi-ze-jiang-qu-xiao-he-cheng-shi-fou-qu-xiao-pai-dui'
//     ),
//     okText: $t('qu-xiao-pai-dui'),
//     onOk: () => handleCancel(record, true),
//   })
// }

// 取消合成或渲染
const handleCancelTask = (record: any) => {
  if (record?.id) {
    useConfirm({
      icon: true,
      title: COPYWRITING_MAP[COLLECTION_MAP.PIECES].title,
      description: COPYWRITING_MAP[COLLECTION_MAP.PIECES].description,
      okText: COPYWRITING_MAP[COLLECTION_MAP.PIECES].okText,
      onOk: () => handleCancel(record),
    })
  }
}
</script>
<style lang="scss" scoped>
.progress-card {
  @apply w-full h-full bg-back-3 relative flex justify-center items-center;
  border-radius: 10px 10px 0px 0px;
  backdrop-filter: blur(0px);
  .tip {
    @apply absolute top-[8px] left-[8px];

    .label {
      @apply text-[10px] leading-[18px] text-font-50;
    }

    .time {
      @apply text-[12px] leading-[18px] text-font-80 font-semibold;
    }
  }

  .content {
    @apply text-center;
    .title {
      @apply text-14 text-font-80 font-semibold;
    }

    .sub-title {
      @apply text-12 text-font-50;
    }

    .init-loading {
      @apply relative w-[48px] h-[48px] rounded-[50%] flex justify-center items-center animate-spin m-auto;
      background-image: conic-gradient(#d9d9e1, #f2f3f3);

      &::before {
        @apply w-[43px] h-[43px] block bg-back-3 rounded-[50%];
        content: '';
        backdrop-filter: blur(0px);
      }
    }
  }
  .lightning {
    animation-name: breath;
    animation-duration: 3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
  @keyframes breath {
    from {
      opacity: 0.2;
    }
    50% {
      opacity: 0.8;
    }
    to {
      opacity: 0.2;
    }
  }
}
</style>
